import { createGlobalStyle } from "styled-components";
import { theme } from "../constants/StyledComponents";

export const GlobalStyles = createGlobalStyle`
  body,
  html {
    margin: 0;
    font-family: "Work Sans", sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    overflow: hidden;
    color: ${theme.colors.black}
  }
  #root {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    overflow: hidden;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .show-mobile {
    display: none;
  }
  .show-desktop {
      display: inherit !important;
    }
  .vertical-container{
    display: flex;
    flex-direction: column;
  }
  .mr-15{
    margin-right: 15px;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: ${theme.colors.white};
    border: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${theme.colors.grey_5};
    border: 1px solid ${theme.colors.grey_5};
  }
  
  #storybook-docs{ height: 100vh; overflow: auto; }

  @media print {
    html, body { 
      height: initial !important; 
      overflow: initial !important; 
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    
    .print-full-height {
      height: auto !important;
      overflow: visible !important;
    }
    
    .no-print {
      display: none !important;
    }
    
    .page-break {
      page-break-inside: avoid;
    }
    
    @page {
      margin: 5mm;
    }
  }

  /* disabled ZOOM iOS mobile */
  @media (max-width: ${({ theme }) => theme.breakpoints.MD}px) {
    input, select, textarea {
      font-size: 16px !important;
    }
  }
`;

export default GlobalStyles;
